import React from "react";
import {
  MessageCircle,
  Handshake,
  SquarePlus,
  Eye,
  Car,
  Clock,
  TrendingUp,
  LucideIcon,
} from "lucide-react";
import { whyMotorPro } from "../content/landingContent";
import { Reveal } from "./Reveal";
import { useContentField, useContentJson } from "../lib/useContent";

const iconMap: Record<string, LucideIcon> = {
  MessageCircle,
  Handshake,
  SquarePlus,
  Eye,
  Car,
  Clock,
  TrendingUp,
};

export const WhyMotorPro: React.FC = () => {
  const title = useContentField("whyMotorPro.title", whyMotorPro.title);
  const intro = useContentField("whyMotorPro.intro", whyMotorPro.intro);
  const benefits = useContentJson("whyMotorPro.benefitsJson", whyMotorPro.benefits);
  return (
    <section
      id="por-que-motorpro"
      data-testid="why-motorpro-section"
      className="bg-white py-20 sm:py-24 lg:py-28"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal className="max-w-2xl">
          <span className="font-display text-xs font-semibold uppercase tracking-[0.2em] text-motor-red">
            Capítulo 01
          </span>
          <h2 className="mt-4 font-display font-bold text-3xl sm:text-4xl lg:text-[2.75rem] text-motor-ink leading-tight">
            {title}
          </h2>
          <p className="mt-5 text-base text-neutral-600 leading-relaxed">{intro}</p>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {benefits.map((benefit, idx) => {
            const Icon = iconMap[benefit.icon] || Car;
            return (
              <Reveal key={benefit.title} delay={idx * 0.06}>
                <div
                  data-testid={`benefit-card-${idx}`}
                  className="h-full rounded-2xl border border-neutral-200 bg-white p-6 hover:border-motor-red/40 hover:shadow-[0_16px_40px_-16px_rgba(200,16,46,0.25)] transition-all duration-300"
                >
                  <div className="h-12 w-12 rounded-xl bg-motor-red/10 flex items-center justify-center">
                    <Icon className="h-5.5 w-5.5 text-motor-red" strokeWidth={2} />
                  </div>
                  <h3 className="mt-5 font-display font-semibold text-base text-motor-ink leading-snug">
                    {benefit.title}
                  </h3>
                  <p className="mt-2.5 text-sm text-neutral-600 leading-relaxed">{benefit.text}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
